export class BookingTypes{
    rowNum :number
    id:number
    abreviatura:string;
    codigo:string;
    descripcion:string;
    material_color:string;
}